<ng-container *ngIf="notification.realConversionsIsEnabled$ | async">
<!--  <span class="badge-status badge-status-success badge-status-not-configured display-flex flex-align-center cursor">-->
<!--    <mat-icon>fence</mat-icon>-->
<!--    <span class="badge-text ml-5">{{ 'Walled garden' | translate }}</span>-->
<!--  </span>-->
</ng-container>
